import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './FeedbackForm.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const FeedbackForm = () => {
    const { phone, invoiceNo } = useParams();
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [comments, setComments] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    // Emoji feedback options
    const emojiRatings = [
        { value: 1, emoji: '😞', label: 'Very Bad', color: '#ef4444' },
        { value: 2, emoji: '😕', label: 'Bad', color: '#f59e0b' },
        { value: 3, emoji: '😐', label: 'Okay', color: '#eab308' },
        { value: 4, emoji: '😊', label: 'Good', color: '#10b981' },
        { value: 5, emoji: '😍', label: 'Excellent', color: '#059669' }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (rating === 0) {
            setError('Please select your feedback');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${API_URL}/api/feedback/submit`, {
                customerPhone: decodeURIComponent(phone),
                invoiceNo: decodeURIComponent(invoiceNo),
                rating,
                comments
            });

            if (response.data.success) {
                setSubmitted(true);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to submit feedback. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="feedback-container">
                <div className="feedback-success">
                    <div className="success-icon">✓</div>
                    <h1>Thank You!</h1>
                    <p>Your feedback has been submitted successfully.</p>
                    <p className="success-message">We appreciate you taking the time to share your experience with us.</p>
                    <button 
                        className="btn-close-feedback"
                        onClick={() => window.history.back()}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="feedback-container">
            <div className="feedback-card">
                <div className="feedback-header">
                    <h1>Rate Your Delivery Experience</h1>
                    <p>Invoice: <strong>{decodeURIComponent(invoiceNo)}</strong></p>
                </div>

                <form onSubmit={handleSubmit} className="feedback-form">
                    <div className="rating-section">
                        <label>How was your delivery experience?</label>
                        <div className="emoji-rating">
                            {emojiRatings.map((item) => (
                                <button
                                    key={item.value}
                                    type="button"
                                    className={`emoji-btn ${rating === item.value ? 'active' : ''} ${hover === item.value ? 'hover' : ''}`}
                                    onClick={() => setRating(item.value)}
                                    onMouseEnter={() => setHover(item.value)}
                                    onMouseLeave={() => setHover(0)}
                                    style={{
                                        borderColor: (rating === item.value || hover === item.value) ? item.color : 'transparent'
                                    }}
                                >
                                    <span className="emoji-icon">{item.emoji}</span>
                                    <span className="emoji-label">{item.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="comments-section">
                        <label htmlFor="comments">Additional Comments (Optional)</label>
                        <textarea
                            id="comments"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Tell us more about your experience..."
                            rows="4"
                            maxLength="500"
                        />
                        <span className="char-count">{comments.length}/500</span>
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="btn-submit-feedback"
                        disabled={loading || rating === 0}
                    >
                        {loading ? 'Submitting...' : 'Submit Feedback'}
                    </button>
                </form>

                <div className="feedback-footer">
                    <p>Your feedback helps us improve our service</p>
                </div>
            </div>
        </div>
    );
};

export default FeedbackForm;
